import type { GA4_EVENT, GA4EventType } from '@ab-core-functions/google-analytics';
import { pushToDataLayer } from '@ab-core-functions/google-analytics';
import { TEMPLATE_IDS, UC_UI } from '@ab-core-functions/usercentrics';
import { useCallback } from 'react';

type UseGoogleAnalyticsTrackingClickProps = {
    event: GA4_EVENT.SELECT_PROMOTION | GA4_EVENT.SELECT_ITEM;
    params: GA4EventType;
};

export const useGoogleAnalyticsTrackingClick = (props: UseGoogleAnalyticsTrackingClickProps) => {
    const { event, params } = props;
    const hasConsent = UC_UI.getConsentByTemplateId(TEMPLATE_IDS.GOOGLE_ANALYTICS);

    const trackClick = useCallback(() => {
        if (!hasConsent) {
            return;
        }

        pushToDataLayer(event, params);
    }, [event, params, hasConsent]);

    return { trackClick };
};
